import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { districtForPath } from "./districts";

export function RouteAnnouncer() {
  const { pathname } = useLocation();
  const first = useRef(true);
  const district = districtForPath(pathname);
  useEffect(() => {
    if (first.current) { first.current = false; return; }
    document.getElementById("main-content")?.focus({ preventScroll: true });
  }, [pathname]);
  return <div className="sr-only" role="status" aria-live="polite" aria-atomic="true">{district.label}</div>;
}
